module.exports = "/call-frontend/img/橙.a6f6d073.png";